import { z } from 'zod';

// Mirrors the Prisma RevokeReason enum (apps/backend/prisma/schema/
// refresh-tokens.prisma). Exported so tests and any future admin UI
// can reference the literal values without reaching into the generated
// Prisma client from shared-land.
//
// Drift between this list and the Prisma enum is caught at CI time by
// scripts/check-enum-sync.sh.
export const RefreshRevokeReasonSchema = z.enum([
  'ROTATION',
  'LOGOUT',
  'LOGOUT_ALL',
  'REUSE',
  'ADMIN_REVOKE',
  'PASSWORD_CHANGED',
  'PASSWORD_RESET',
]);
export type RefreshRevokeReason = z.infer<typeof RefreshRevokeReasonSchema>;
